export const GET_GLOBAL_PROPERTIES = "GET_GLOBAL_PROPERTIES";
export const GET_GLOBAL_PROPERTY_BY_UUID = "GET_GLOBAL_PROPERTY_BY_UUID";
export const POST_GLOBAL_PROPERTY = "POST_GLOBAL_PROPERTY";
export const PUT_GLOBAL_PROPERTY = "PUT_GLOBAL_PROPERTY"; 
